module.exports = __webpack_public_path__ + "img/MM.24f5d6c1.svg";